import {
  DATA_CONNECTOR_CREATE_COLLECTION_WITH_XATA_BEGIN,
  DATA_CONNECTOR_CREATE_COLLECTION_WITH_XATA_SUCCESS,
  DATA_CONNECTOR_CREATE_COLLECTION_WITH_XATA_FAILURE,
  DATA_CONNECTOR_CREATE_COLLECTION_WITH_XATA_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
export function createCollectionWithXata(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_CREATE_COLLECTION_WITH_XATA_BEGIN,
    });
    const { version, projectId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/xata/create-collection`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_CREATE_COLLECTION_WITH_XATA_SUCCESS,
            data: res,
          });
          Mixpanel.track('Created Collection', {
            uuid: res.data.uuid,
            colletionName: res.data.colletionName,
          });
          toast.success('Collection Created Successfully !');
          resolve(res);
        },
        (err) => {
          const errMsg = getErrorMessageFromResponse(err.response);
          console.log('err', err.response);
          toast.error(`Failed: Collection with This Name Already exists`);
          Mixpanel.track('Failed to creat collection');
          dispatch({
            type: DATA_CONNECTOR_CREATE_COLLECTION_WITH_XATA_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateCollectionWithXataError() {
  return {
    type: DATA_CONNECTOR_CREATE_COLLECTION_WITH_XATA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_CREATE_COLLECTION_WITH_XATA_BEGIN:
      return {
        ...state,
        createCollectionWithXataPending: true,
        createCollectionWithXataError: null,
      };

    case DATA_CONNECTOR_CREATE_COLLECTION_WITH_XATA_SUCCESS:
      return {
        ...state,
        createCollectionWithXataPending: false,
        createCollectionWithXataError: null,
      };

    case DATA_CONNECTOR_CREATE_COLLECTION_WITH_XATA_FAILURE:
      return {
        ...state,
        createCollectionWithXataPending: false,
        createCollectionWithXataError: action.data.error,
      };

    case DATA_CONNECTOR_CREATE_COLLECTION_WITH_XATA_DISMISS_ERROR:
      return {
        ...state,
        createCollectionWithXataError: null,
      };
    default:
      return state;
  }
}
